import React from 'react'
import Button from 'components/button'
import { assetPrefix } from 'src/config/env_config'
import PackageAdhesionTermsContent from './content'
import * as S from './styles'

const PackageAdhesionTerms = ({
  onTermsAction,
  onClose,
  hideActionButtons,
  hideButtons
}) => {
  return (
    <>
      <S.Header>
        <S.ImageContainer>
          <img
            src={`${assetPrefix}/static/images/package-adhesion-term.svg`}
            alt='Termo de Adesão ao Pacote de Banhos Pet Anjo'
          />
        </S.ImageContainer>
        <S.Title>Termo de Adesão ao Pacote de Banhos Pet Anjo</S.Title>
      </S.Header>

      <S.Container>
        <PackageAdhesionTermsContent />
      </S.Container>

      {!hideButtons && (
        <S.Footer>
          {hideActionButtons ? (
            <Button theme='primary' onClick={() => onClose?.()}>Fechar</Button>
          ) : (
            <>
              <Button theme='secondary' onClick={() => onTermsAction?.('deny')}>Não concordo</Button>
              <Button onClick={() => onTermsAction?.('accept')}>Li e concordo</Button>
            </>
          )}
        </S.Footer>
      )}
    </>
  )
}

export default PackageAdhesionTerms
